import PluggableElementBase from "./PluggableElementBase.js";
export default class InternetAccountType extends PluggableElementBase {
    stateModel;
    configSchema;
    constructor(stuff) {
        super(stuff);
        this.stateModel = stuff.stateModel;
        this.configSchema = stuff.configSchema;
    }
}
